import { makeStyles } from 'tss-react/mui';

const name = 'AAPIInfoTabs';

export const useAAPIInfoTabsStyles = makeStyles({ name })(theme => ({
  advancedApiInfoTabsPaper: {
    backgroundImage: 'none',
    padding: theme.spacing(6, 8),
    minHeight: 264,

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(5.5, 4),
    },
  },
  advancedApiInfoTabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
  },
  advancedApiInfoTabsInner: {
    gap: theme.spacing(4),
  },

  /* Tabs */
  advancedApiPrimaryTab: {
    marginRight: 0,
    fontSize: 16,
    boxShadow: 'none',

    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
}));
